﻿import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlGridTagNames } from './grid.props';

@customElement(AtlGridTagNames.InnerRow)
export class AtlGridInnerRow extends LitElement {
   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   render() {
      const classNameBuilder = ['row', 'grid-inner-row'];
      return html`
         <div class=${classNameBuilder.join(' ')}>
            <slot></slot>
         </div>
      `;
   }
}
